import { ENVIRONMENT_CONSTANT } from "./env.constant";

export const CREATE_CUSTOM_FIELD = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}custom-fields/create`;
export const GET_CAMPAIGN_CUSTOM_FIELDS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}custom-fields/getall/`;
export const GET_DONOR_CUSTOM_FIELDS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}custom-fields/donors/`;
export const GET_ENTITY_FIELDS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}custom-fields/entity/`;
export const ARCHIVE_CUSTOM_FIELD = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}custom-fields/archive/`;
export const ATTACH_CUSTOM_FIELD = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}custom-fields/attach/`;
export const UPDATE_CUSTOM_FIELD_ANSWERS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}custom-fields/update-answers/`;
export const GET_CUSTOM_FIELD_ANSWER_BY_ENTITY = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}custom-fields/get-answers/`;
export const SORT_CUSTOM_FIELD = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}custom-fields/sort`;
